import React, { useEffect, useState } from 'react';
import { FaCamera } from 'react-icons/fa';

// What the read is doing, stepped through while it runs so the wait doesn't
// feel stuck. The last step holds until the result arrives.
const FIRST_READ_STEPS = [
  'Reading the text on your card…',
  'Finding the player, year and set…',
  'Checking the card number and grade…',
];
const REREAD_STEPS = [
  'Reading the back for the card number and year…',
];
const STEP_MS = 2500;

// Auto-identify status for add-card forms. Purely informational -- the form
// is always usable regardless of what happens here.
const IdentifyStatus = ({ identifying, rereading = false, note }) => {
  const [step, setStep] = useState(0);
  const steps = rereading ? REREAD_STEPS : FIRST_READ_STEPS;

  useEffect(() => {
    setStep(0);
    if (!identifying) return undefined;
    const id = setInterval(() => {
      setStep(s => Math.min(s + 1, steps.length - 1));
    }, STEP_MS);
    return () => clearInterval(id);
  }, [identifying, steps.length]);

  if (!identifying && !note) return null;
  return (
    <div className={`identify-status${identifying ? ' is-working' : ''}`} role="status" aria-live="polite">
      {identifying ? (
        <>
          <span className="identify-spinner" aria-hidden="true" />
          <div>
            <strong>Auto-filling from your photos</strong>
            <span className="identify-step">{steps[Math.min(step, steps.length - 1)]}</span>
            <span className="identify-hint-text">Usually 5–10 seconds. You can keep going while it works.</span>
          </div>
        </>
      ) : (
        <span>{note}</span>
      )}
    </div>
  );
};

// Shown at the top of an empty add-card form so people upload photos first
// instead of typing details that auto-identify would have filled in.
export const PhotoFirstHint = () => (
  <div className="identify-hint">
    <FaCamera className="identify-hint-icon" aria-hidden="true" />
    <div>
      <strong>Start with photos</strong>
      <span>Add the front and back of your card and we'll read it and fill in the details for you.</span>
    </div>
  </div>
);

export default IdentifyStatus;
